const c = {
  name: "Hands110002",
  dimensions: { width: 35, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 38" style="enable-background:new 0 0 35 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M35,25v-9c0-2.2-1.8-4-4-4c-0.8,0-1.6,0.2-2.2,0.7c-0.5-1.6-2-2.7-3.8-2.7c-0.8,0-1.6,0.2-2.2,0.7
			C22.2,9.1,20.8,8,19,8c-0.7,0-1.4,0.2-2,0.5V4c0-2.2-1.8-4-4-4c-2.2,0-4,1.8-4,4v15.5l-2-2.1c-1.4-1.7-3.9-1.9-5.6-0.5
			c-1.7,1.4-1.9,3.9-0.5,5.6l1.9,2.3l6.7,7.5C12.7,36,17.3,38,22,38C29.2,38,35,32.2,35,25z M11,4c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2
			v12h2v-4c0-1.1,0.9-2,2-2s2,0.9,2,2v4h2v-2c0-1.1,0.9-2,2-2s2,0.9,2,2v2h2c0-1.1,0.9-2,2-2s2,0.9,2,2v9c0,6.1-4.9,11-11,11
			c-4.2,0-8.1-1.8-10.9-4.9l-6.7-7.5l-1.9-2.3c-0.7-0.8-0.6-2.1,0.2-2.8c0.8-0.7,2.1-0.6,2.8,0.2l0,0l5.4,5.7V4z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hands110002
};
